import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { PopupService } from '../general/popup.service';
import { ErrorService } from '../general/error.service';
import { AccountInfoService } from '../account/account-info.service';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class BlastMigrateService implements OnInit, OnDestroy {

  constructor(
    private translate: TranslateService,
    private fns: AngularFireFunctions,
    private accountInfoService: AccountInfoService,
    private popupService: PopupService,
    private errorService: ErrorService,
  ) { }

  ngOnInit(): void {
      
  }

  ngOnDestroy(): void {
      
  }

  async upgrade() {
    await this.popupService.presentLoading();
    const accountId = this.accountInfoService.accountId;
    await this.fns.httpsCallable('upgradeBlastDbCall')({ accountId })
    .toPromise().then(async (result: any) => {
      this.popupService.dismissLoading();
    }).catch((err: any) => {
      this.errorService.logError(err);
      this.popupService.presentAlert(this.translate.instant('MSG.action_error'));
    });
    this.popupService.dismissLoading();
  }
}
